import { createContext } from "react";

/**
 * SharedAudio is the reader's one <audio> element, held by the page above the
 * chapter so it outlives moving from one chapter to the next (ADR-0177).
 *
 * Auto-play's next chapter starts without a tap, and a browser that refuses
 * play() without one — Safari on iOS — still lets an element the listener has
 * already started play again. A fresh element per chapter would be refused.
 * The studio has none and its player keeps its own element.
 */
export const SharedAudio = createContext<HTMLAudioElement | null>(null);
